import axios from 'axios'

export default {
    namespaced: true,
    state: {
        clients : []
    },
    getters: {
        GET_SELECT_LIST(state) {
            return state.clients.map((item) => {
                return {text: item.name, value: item.id}
            })
        }
    },
    mutations: {
        FETCH_CLIENTS(state, clients) {
            state.clients = clients
        },
        EDIT_CLIENTS(state, clients) {
            const index = state.clients.findIndex(
                item => item.id === clients.id
            )
            Object.assign(state.clients[index], clients)
        },
        DEL_CLIENTS(state, client) {
            const index = state.clients.findIndex(
                item => item.id === client.id
            )
            state.clients.splice(index, 1)
        }
    },
    actions: {
        find({commit, dispatch, state}, phone) {
            return new Promise((resolve, reject) => {
                axios.get(
                    '/api/mixins/clients/find', {
                        params: { phone }
                    }
                ).then(({data}) => {
                    resolve(data.data)
                }).catch((error) => {
                    reject(error)
                })
            })
        },
        fetch({commit, dispatch, state}, payload = {}) {
            // todo записывать фильтр в state что не повторять запрос
            if (typeof payload.isPreload === 'undefined') {
                commit('TOGGLE_PRELOADER', true, {root: true})
            }
            return axios.post(
                '/api/mixins/clients/list', payload.filter
            ).finally(() => {
                if (typeof payload.isPreload === 'undefined') {
                    commit('TOGGLE_PRELOADER', false, {root: true})
                }
            }).then(({data}) => {
                commit('FETCH_CLIENTS', data.data)
            }).catch((error) => {
                dispatch('checkUnauthenticated', error, { root: true })
            })
        },
        edit({commit, dispatch}, editedItem) {
            return axios.put(
                '/api/mixins/clients/edit/' + editedItem.id,
                editedItem
            ).then(({data}) => {
                commit('EDIT_CLIENTS', data.data)
            }).catch((error) => {
                dispatch('checkUnauthenticated', error, { root: true })
            })
        },
        delete({commit, dispatch, state}, itemId) {
            return axios.delete(
                '/api/mixins/clients/dell/' + itemId
            ).then(({data}) => {
                commit('DEL_CLIENTS', data.data)
            }).catch((error) => {
                dispatch('checkUnauthenticated', error, { root: true })
            })
        },
    }
}
